import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import ChangeRequestDetails from "./ChangeRequestDetails";
import ChangeRequestHeader from "./ChangeRequestHeader";
import { useParams } from "react-router-dom";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import FurtherInformation from "./FurtherInformation";
import Page500 from "../../../pages/auth/Page500";
import {
  loadChangeRequestAsync,
  selectChangeRequest,
} from "../../../redux/slices/changeRequest";

const ChangeRequest = () => {
  const [loading, setLoading] = useState(false);
  const [loadingChangeRequestId, setLoadingLiceneActionId] = useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const changeRequestSelector = useAppSelector(selectChangeRequest);

  const dispatch = useAppDispatch();

  let { profileNo, changeRequestId } = useParams();
  if (!profileNo || !changeRequestId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
    return <Loading />;
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingChangeRequestId !== changeRequestId) {
    setLoadingLiceneActionId(changeRequestId);
    dispatch(loadChangeRequestAsync(changeRequestId));
    return <Loading />;
  }

  const changeRequestDetails = changeRequestSelector.changeRequest;

  if (!changeRequestDetails) {
    return <Loading />;
  }

  if (!changeRequestDetails.response.ok) {
    if (changeRequestDetails.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <ChangeRequestHeader changeRequestDetails={changeRequestDetails} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <ChangeRequestDetails changeRequestDetails={changeRequestDetails} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <FurtherInformation
            changeRequestDetails={changeRequestDetails}
            licenceProfile={licenceProfile}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs
        licenceProfile={licenceProfile}
        changeRequestDetails={changeRequestDetails}
      />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="licence-versions"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default ChangeRequest;
